import * as React from "react";
import { forwardRef } from "react";
const SvgLateNightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.32724 16.6546C10.1937 16.6546 11.9166 16.0444 13.3164 15.0035C10.3732 13.7113 8.32724 10.7681 8.32724 7.35821C8.32724 4.63032 9.65529 2.22548 11.6653 0.682064C10.6603 0.251345 9.51172 9.15527e-05 8.32724 9.15527e-05C3.7329 9.15527e-05 0 3.73299 0 8.32733C0 12.9217 3.7329 16.6546 8.32724 16.6546Z", fill: "black" }));
const ForwardRef = forwardRef(SvgLateNightIcon);
export default ForwardRef;
